import PropTypes from 'prop-types'
import React from 'react'

const MediaCategoryItem = ({ children }) => (
  <div
    className="mt-3 flex min-h-56 justify-items-center overflow-x-auto border-t-4 border-solid border-blue-300 bg-gray-130 p-5 md:mt-5"
    data-testid="media-category-item"
  >
    {children}
  </div>
)

MediaCategoryItem.propTypes = {
  children: PropTypes.object.isRequired,
}

export default MediaCategoryItem
